export default "__VITE_ASSET__6b3f838a__"